import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Home from "../pages/home";
import LoginPage from "../pages/loginpage";
import { signOut, getAuth } from "firebase/auth";
import Post from "../pages/posts";
import { Routes, Route, Link, useNavigate, Navigate } from "react-router-dom";
import { FaSignOutAlt } from "react-icons/fa";
import { CgProfile } from "react-icons/cg";

//import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import BlogDescription from "../pages/blogDescription";
import { IoMdHome } from "react-icons/io";
import { FaSearch } from "react-icons/fa";
import { FaPencilAlt } from "react-icons/fa";
import Profile from "../pages/profile";
import Register from "../pages/Register";
import { onAuthStateChanged } from "firebase/auth";
import { useEffect } from "react";
import { ProtectedRoute, PublicRoute } from "./protectedRoute";
import ResetPassword from "../pages/ResetPassword ";

const Navbar = () => {
  const auth = getAuth();
  //const [isAuth, setIsAuth] = useState(localStorage.getItem("isAuth"));
  const [isOpen, setIsOpen] = useState(false);
  const [isAuth, setIsAuth] = useState(null);
  const [authUser, setAuthUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);

  const navigate = useNavigate();
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setAuthUser(user);
      setAuthLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const signUserOut = () => {
    signOut(auth)
      .then(() => {
        localStorage.clear();
        setIsAuth(false);
        navigate = "/";
      })
      .catch((error) => {
        console.log(`this is the error${error}`);
      });
  };
  return (
    <div className="bg-blue-950">
      <nav className="bg-white border-b shadow-md">
        <div className="max-w-screen-xl mx-auto px-4 py-3 flex items-center justify-between">
          <div className="flex items-center">
            <p href="#" className="text-lg font-semibold ">
              <Link className="navbar-brand" to="/home">
                AMAHAN
              </Link>
            </p>
          </div>
          {/* <div className="relative w-full max-w-md">
            <FaSearch
              size={16}
              className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
            />

            <input
              type="text"
              placeholder="Search Articles, Topics, etc..."
              className="
                w-full h-11 pl-10 pr-4
                rounded-xl border border-gray-300 
                focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent
                text-gray-700 placeholder-gray-400
                transition
                "
            />
          </div> */}

          <div className="hidden lg:flex space-x-6">
            {/* <p
              href="#"
              className="text-blue-gray-900 hover:text-blue-500 transition-colors"
            >
              <Link className="nav-link active" aria-current="page" to="/home">
                {" "}
                Home
              </Link>
            </p> */}
            {!isAuth ? (
              <p
                href="#"
                className="text-blue-gray-900 hover:text-blue-500 transition-colors"
              >
                <Link className="nav-link active" aria-current="page" to="/">
                  Login
                </Link>
              </p>
            ) : (
              <>
                <p
                  href="#"
                  className="text-white rounded-xl bg-blue-700 hover:text-blue-500 transition-colors"
                >
                  <Link
                    className="nav-link active"
                    aria-current="page"
                    onClick={signUserOut}
                  >
                    <span className="flex items-center gap-2 p-2">
                      <FaSignOutAlt /> SignOut
                    </span>
                  </Link>
                </p>
                <p
                  href="#"
                  className="text-white rounded-xl bg-blue-700 hover:text-blue-500 transition-colors"
                >
                  <Link
                    className="nav-link active"
                    aria-current="page"
                    to="/posts"
                  >
                    <span className="flex items-center gap-2 p-2">
                      <FaPencilAlt /> Create Post
                    </span>
                  </Link>
                </p>
                <p
                  href="#"
                  className="bg-blue-700 text-white rounded-xl hover:text-blue-500 transition-colors"
                >
                  <Link
                    className="nav-link active"
                    aria-current="page"
                    to="/home"
                  >
                    <span className="flex items-center gap-2 p-2">
                      <IoMdHome /> Home
                    </span>
                  </Link>
                </p>

                <p
                  href="#"
                  className="bg-blue-700 text-white rounded-xl hover:text-blue-500 transition-colors"
                >
                  <Link
                    className="nav-link active"
                    aria-current="page"
                    to="/profile"
                  >
                    <span className="flex items-center gap-2 p-2">
                      <CgProfile /> Profile
                    </span>
                  </Link>
                </p>
              </>
            )}
          </div>
          <div className="lg:hidden">
            <button
              className="text-blue-gray-900"
              onClick={() => setIsOpen(!isOpen)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </button>
          </div>
        </div>
        {isOpen && (
          <div className="lg:hidden bg-white shadow-md border-t">
            <div className="px-4 py-2 space-y-2">
              <p className="block text-blue-gray-900 hover:text-blue-500 transition-colors">
                <Link
                  className="nav-link active"
                  aria-current="page"
                  to="/home"
                >
                  {" "}
                  Home
                </Link>
              </p>
              {!isAuth ? (
                <p className="block text-blue-gray-900 hover:text-blue-500 transition-colors">
                  <Link
                    className="nav-link active"
                    aria-current="page"
                    to="/signup"
                  >
                    Login
                  </Link>
                </p>
              ) : (
                <>
                  <p className="block text-blue-gray-900 hover:text-blue-500 transition-colors">
                    <Link
                      className="nav-link active"
                      aria-current="page"
                      onClick={signUserOut}
                    >
                      Signout
                    </Link>
                  </p>
                  <p className="block text-blue-gray-900 hover:text-blue-500 transition-colors">
                    <Link
                      className="nav-link active"
                      aria-current="page"
                      to="/posts"
                    >
                      Post
                    </Link>
                  </p>
                  <p className="block text-blue-gray-900 hover:text-blue-500 transition-colors">
                    <Link
                      className="nav-link active"
                      aria-current="page"
                      to="/profile"
                    >
                      Profile
                    </Link>
                  </p>
                </>
              )}
            </div>
          </div>
        )}
      </nav>

      <Routes>
        <Route path="/profile" element={<Profile />} />
          <Route
            path="/blogdescription/:id"
            element={<BlogDescription isAuth={isAuth} />}
          />
          <Route path="/register" element={<Register />}/>
          <Route path="/home" element={<Home isAuth={isAuth} />} />
          <Route path="/" element={<LoginPage setIsAuth={setIsAuth} />} />
          <Route path="/posts" element={<Post isAuth={isAuth} />} /> 
          <Route path="/reset-password" element={<ResetPassword />} />


        
        {/* <Route
    path="/"
    element={
      <PublicRoute isAuth={isAuth}>
        <LoginPage setIsAuth={setIsAuth} />
      </PublicRoute>
    }
  />

  <Route
    path="/register"
    element={
      <PublicRoute isAuth={isAuth}>
        <Register />
      </PublicRoute>
    }
  />

  <Route
    path="/home"
    element={
      <ProtectedRoute isAuth={isAuth}>
        <Home isAuth={isAuth} />
      </ProtectedRoute>
    }
  />


  <Route
  path="/posts"
  element={
    <ProtectedRoute authUser={authUser} authLoading={authLoading}>
      <Post />
    </ProtectedRoute>
  }
/> */}

        {/* <Route
    path="/posts"
    element={
      <ProtectedRoute isAuth={isAuth}>
        <Post isAuth={isAuth} />
      </ProtectedRoute>
    }
  /> */}

        {/* <Route
    path="/profile"
    element={
      <ProtectedRoute isAuth={isAuth}>
        <Profile />
      </ProtectedRoute>
    }
  />

  <Route
    path="/blogdescription/:id"
    element={<BlogDescription isAuth={isAuth} />}
  /> */}
      </Routes>
    </div>
  );
};

export default Navbar;
